<template>
    <input type="checkbox" class="toggle-switch" v-model="isChecked">
</template>

<script setup>
    import { defineModel } from 'vue'
    const isChecked = defineModel('isChecked')
</script>

<style scoped>
    .toggle-switch {
        appearance: none;
        position: relative;
        width: 35px;
        height: 20px;
        border-radius: 25px;
        background-color: #ccc;
        transition: background .3s;
        outline: none;
        cursor: pointer;
    }
    .toggle-switch::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 30%;
        transform: translate(-50%, -50%);
        border-radius: 50%;
        height: .9rem;
        width: .9rem;
        background-color: rgb(255, 255, 255);
        transition: left .3s;
    }
    .toggle-switch:checked {
        background-color: #0A84FF;
    }

    .toggle-switch:checked::after {
        left: 70%;
    }

</style>
